var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3600 3000",
    id: "Businessfinancemanagement",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    viewBox: "0 0 311.01 356.37"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m302.47,244.15l-142.34,110.45c-3.66,2.84-8.94,2.18-11.78-1.49L.88,156.51c-1.42-1.83-1.09-4.47.74-5.89L140.87,43.69c3.66-2.84,8.94-2.18,11.78,1.49l150.57,193.09c1.42,1.83,1.09,4.47-.74,5.89Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m290.94,189.51l-29.99-8.86L151.74,40.6c-2.62-3.37-7.48-3.99-10.85-1.37L41.3,115.72l-29.9-8.84v34.93c0,.87.28,1.71.8,2.41l135.59,180.03c2.62,3.37,7.48,3.99,10.85,1.37l130.74-100.54c.98-.76,1.56-1.93,1.56-3.17v-32.41Z",
    className: "colorffcb00 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9c27b0",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    points: "291.54 187.71 291.54 224.91 153.3 330.51 153.3 295.47 291.54 187.71",
    className: "colorfe8628 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.78,
    x2: 153.78,
    y1: 325.59,
    y2: 292.47,
    fill: "#ffcb00",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    className: "colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f4f8",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m289.39,191.27l-131.11,101.74c-3.37,2.62-8.23,2.01-10.85-1.37L11.59,110.54c-1.31-1.69-1-4.12.68-5.42L140.54,6.62c3.37-2.62,8.23-2.01,10.85,1.37l138.69,177.86c1.31,1.69,1,4.12-.68,5.42Z",
    className: "colorfff6ef svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.67,
    x2: 166.95,
    y1: 102.87,
    y2: 255.37,
    fill: "none",
    stroke: "#c9e4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStrokeffd5c9 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.04,
    x2: 206.6,
    y1: 72.37,
    y2: 223.77,
    fill: "none",
    stroke: "#c9e4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStrokeffd5c9 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.41,
    x2: 246.97,
    y1: 41.87,
    y2: 193.27,
    fill: "none",
    stroke: "#c9e4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStrokeffd5c9 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m284.74,176.37l-12.58,9.81c-3.07,2.38-7.54.27-7.63-3.62l-.15-6.47c-.05-2.37-1.85-4.32-4.2-4.59l-193.51-21.42c-2.6-.28-4.47-2.63-4.17-5.23l4.98-43.56c.33-2.88,3.15-4.78,5.94-4.02l184.83,50.74c1.3.36,2.61.13,3.65-.5l22.84,28.87Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0047ab",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    points: "77.27 87.06 273.52 140.93 273.17 122.03 306.01 158.19 273.91 183.22 273.46 163.21 71.12 140.81 77.27 87.06",
    className: "color0094ff svgShape colorStroke232526 svgStroke"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "0 0 1516.16 1530.68"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m1454.83,658.39l53.04,72.8c13.77,18.9,10,45.33-8.51,59.63l-946.44,725.11c-31.31,24.19-76.39,17.95-99.95-13.84L8.5,902.43c-14.27-19.25-10.15-46.43,9.18-60.59l116.32-85.18,1312.01-102.43c3.46-.21,6.78,1.35,8.82,4.15Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m1497,697.67c.67,33.04-8.26,31.7-23.22,46.44-1.47,1.44-688.66,525.8-904.65,692.52-24.19,18.67-58.98,13.98-77.35-10.44L55.6,846.5c-12.21-18.16-11.93-30.07-11.91-32.15l1.71-59.24,738.76-423.79,713.32,327.06-.49,39.29Z",
    className: "color2b4740 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m1041.54,22.53l444.13,598.98c18.38,21.68,14.82,54.35-7.8,71.57l-916.48,691.57c-21.82,16.6-52.97,12.36-69.55-9.47L53.15,786.6c-16.65-21.92-12.27-53.21,9.76-69.71L973.95,14.91c21-15.73,50.62-12.39,67.59,7.62Z",
    className: "color0094ff svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.19,
    cy: 1053.9,
    r: 26.79,
    fill: "#ffffff",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f4f8",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m1386.87,691.06l-810.04,616.11c-21.65,16.63-52.66,12.64-69.4-8.92l-156.2-201.18c16.75-7.57,28.4-24.41,28.4-43.98,0-26.63-21.59-48.22-48.22-48.22-15.25,0-28.85,7.08-37.68,18.14l-174.67-224.96c-16.86-21.71-12.85-52.99,8.94-69.75L948.82,102.89c22-16.92,53.58-12.51,70.11,9.78l377.58,509.49c16.11,21.75,11.83,52.4-9.64,68.89Z",
    className: "colorfff6ef svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 717.41,
    x2: 1033.65,
    y1: 412.37,
    y2: 836.84,
    fill: "#ffd5c9",
    stroke: "#c9e4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStrokeffd5c9 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 759.38,
    x2: 1075.5,
    y1: 380.65,
    y2: 805.11,
    fill: "#ffd5c9",
    stroke: "#c9e4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStrokeffd5c9 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 801.34,
    x2: 1117.8,
    y1: 348.92,
    y2: 773.61,
    fill: "#ffd5c9",
    stroke: "#c9e4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStrokeffd5c9 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 843.75,
    x2: 1159.52,
    y1: 317.65,
    y2: 741.85,
    fill: "#ffd5c9",
    stroke: "#c9e4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStrokeffd5c9 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 885.71,
    x2: 1201.28,
    y1: 285.92,
    y2: 709.94,
    fill: "#ffd5c9",
    stroke: "#c9e4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    className: "colorStrokeffd5c9 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m940.3,709.51l35.58,47.72c1.67,2.23,4.83,2.67,7.05.98l175.57-134.3c2.17-1.66,2.61-4.77.97-6.96l-35.58-47.72c-1.67-2.23-4.83-2.67-7.05-.98l-175.57,134.3c-2.17,1.66-2.61,4.77-.97,6.96Z",
    className: "color0094ff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9e4ff",
    d: "m600.24 903.78 121.22 162.58c1.44 1.93 4.19 2.32 6.1.85l22.5-17.21c1.88-1.44 2.26-4.13.84-6.03l-121.22-162.58c-1.44-1.93-4.19-2.32-6.1-.85l-22.5 17.21c-1.88 1.44-2.26 4.13-.84 6.03ZM512.75 1028.77l92.65 124.19c1.44 1.93 4.19 2.32 6.1.85l22.5-17.21c1.88-1.44 2.26-4.13.84-6.03l-92.65-124.19c-1.44-1.93-4.19-2.32-6.1-.85l-22.5 17.21c-1.88 1.44-2.26 4.13-.84 6.03ZM572.73 982.89l93.65 125.6c1.44 1.93 4.19 2.32 6.1.85l22.5-17.21c1.88-1.44 2.26-4.13.84-6.03l-93.65-125.6c-1.44-1.93-4.19-2.32-6.1-.85l-22.5 17.21c-1.88 1.44-2.26 4.13-.84 6.03ZM387.79 806.63l-22.5 17.21c-1.88 1.44-2.26 4.13-.84 6.03l132.67 177.93c1.44 1.93 4.19 2.32 6.1.85l22.5-17.21c1.88-1.44 2.26-4.13.84-6.03l-132.67-177.93c-1.44-1.93-4.19-2.32-6.1-.85ZM317.52 712.4l-22.5 17.21c-1.88 1.44-2.26 4.13-.84 6.03l54.63 73.26c1.44 1.93 4.19 2.32 6.1.85l22.5-17.21c1.88-1.44 2.26-4.13.84-6.03l-54.63-73.26c-1.44-1.93-4.19-2.32-6.1-.85ZM687.89 895.96l93.65 125.6c1.44 1.93 4.19 2.32 6.1.85l22.5-17.21c1.88-1.44 2.26-4.13.84-6.03l-93.65-125.6c-1.44-1.93-4.19-2.32-6.1-.85l-22.5 17.21c-1.88 1.44-2.26 4.13-.84 6.03ZM562.93 673.82l-22.5 17.21c-1.88 1.44-2.26 4.13-.84 6.03l132.67 177.93c1.44 1.93 4.19 2.32 6.1.85l22.5-17.21c1.88-1.44 2.26-4.13.84-6.03l-132.67-177.93c-1.44-1.93-4.19-2.32-6.1-.85ZM492.67 579.58l-22.5 17.21c-1.88 1.44-2.26 4.13-.84 6.03l54.63 73.26c1.44 1.93 4.19 2.32 6.1.85l22.5-17.21c1.88-1.44 2.26-4.13.84-6.03l-54.63-73.26c-1.44-1.93-4.19-2.32-6.1-.85ZM858.03 767.39l93.28 125.11c1.44 1.93 4.17 2.31 6.08.85l22.41-17.14c1.88-1.43 2.25-4.11.84-6l-93.28-125.11c-1.44-1.93-4.17-2.31-6.08-.85l-22.41 17.14c-1.88 1.43-2.25 4.11-.84 6ZM733.55 546.11l-22.41 17.14c-1.88 1.43-2.25 4.11-.84 6l132.15 177.24c1.44 1.93 4.17 2.31 6.08.85l22.41-17.14c1.88-1.43 2.25-4.11.84-6l-132.15-177.24c-1.44-1.93-4.17-2.31-6.08-.85ZM663.55 452.24l-22.41 17.14c-1.88 1.43-2.25 4.11-.84 6l54.41 72.98c1.44 1.93 4.17 2.31 6.08.85l22.41-17.14c1.88-1.43 2.25-4.11.84-6l-54.41-72.98c-1.44-1.93-4.17-2.31-6.08-.85ZM608.84 845.93l-165.74-222.47c-1.54-2.06-4.46-2.47-6.5-.91l-81.14 61.01c-2.01 1.53-2.4 4.4-.9 6.42l166.33 223.08c1.54 2.06 4.46 2.47 6.5.91l80.55-61.61c2.01-1.53 2.4-4.4.9-6.42Z",
    className: "colorffd5c9 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m699.63,646.31l-88.22-118.32c-9.45-12.68-27.48-15.09-39.94-5.36h0c-12.06,9.43-14.39,26.76-5.23,39.04l88.22,118.32c9.45,12.68,27.48,15.09,39.94,5.36h0c12.06-9.43,14.39-26.76,5.23-39.04Z",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    d: "m778.56,753.33l-88.22-118.32c-9.45-12.68-27.48-15.09-39.94-5.36h0c-12.06,9.43-14.39,26.76-5.23,39.04l88.22,118.32c9.45,12.68,27.48,15.09,39.94,5.36h0c12.06-9.43,14.39-26.76,5.23-39.04Z",
    className: "colorffcb00 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m893.33,906.86l-126.82-170.12c-9.45-12.68-27.48-15.09-39.94-5.36h0c-12.06,9.43-14.39,26.76-5.23,39.04l126.82,170.12c9.45,12.68,27.48,15.09,39.94,5.36h0c12.06-9.43,14.39-26.76,5.23-39.04Z",
    className: "color0094ff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m753.29,458.7l35.58,47.72c1.67,2.23,4.83,2.67,7.05.98l72.13-55.17c2.17-1.66,2.61-4.77.97-6.96l-35.58-47.72c-1.67-2.23-4.83-2.67-7.05-.98l-72.13,55.17c-2.17,1.66-2.61,4.77-.97,6.96Z",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    d: "m1023.89,523.73l-35.58-47.72c-1.67-2.23-4.83-2.67-7.05-.98l-133.49,102.12c-2.17,1.66-2.61,4.77-.97,6.96l35.58,47.72c1.67,2.23,4.83,2.67,7.05.98l133.49-102.11c2.17-1.66,2.61-4.77.97-6.96Z",
    className: "colorffcb00 svgShape"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    viewBox: "0 0 893.95 887.96"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m386.67,828.08L2.98,313.4c-4.96-6.58-3.58-15.95,3.07-20.83L350.03,31.7c6.53-4.79,15.69-3.44,20.56,3.02l385.86,513.99c4.96,6.58,3.59,15.94-3.05,20.82l-346.15,261.56c-6.53,4.8-15.7,3.46-20.58-3.02Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m388.25,786.65L13,283.3c-4.85-6.44-3.5-15.6,3-20.37L352.41,7.8c6.38-4.68,15.35-3.37,20.11,2.96l377.36,502.68c4.85,6.43,3.51,15.59-2.98,20.36l-338.53,255.8c-6.38,4.7-15.36,3.38-20.13-2.95Z",
    className: "colorffcb00 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#0080ff",
    stroke: "#232526",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    points: "398.59 51.38 401.44 102.38 271.56 252.9 271.21 253.3 270.72 253.51 88.58 333.19 40.69 315.42",
    className: "colorffcb00 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.26,
    cy: 201.91,
    r: 27.99,
    fill: "#9c27b0",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.38,
    cy: 307.52,
    r: 27.99,
    fill: "#9c27b0",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M291.38 325.2c-29.92-34.51-57.26-71.24-81.64-109.86 29.95 34.49 57.23 71.26 81.64 109.86h0ZM339.05 294.09c-29.92-34.51-57.26-71.24-81.64-109.86 29.95 34.49 57.23 71.26 81.64 109.86h0ZM621.24 887.94c2.43.15 4.84-.59 6.77-2.07l251.6-192.61c5.71-4.37 6.76-12.55 2.35-18.22L510.21 193.23c-4.35-5.59-12.38-6.65-18.03-2.38l-307.17 232.33c-5.76 4.35-6.84 12.57-2.41 18.27l337.17 436.89c1.79 2.32 4.49 3.75 7.42 3.93l94.05 5.68Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f4f8",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m626.04,850.71l257.77-197.34c5.78-4.42,6.85-12.7,2.38-18.45l-360.3-463.69c-4.4-5.66-12.53-6.74-18.25-2.41l-310.99,235.22c-5.83,4.41-6.92,12.73-2.44,18.5l328.14,421.91,103.69,6.26Z",
    className: "colorfff6ef svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m626.04,850.71l-45.93-40.69c-3.65-3.24-9.09-3.41-12.95-.42l-44.82,34.85,103.69,6.26Z",
    className: "color0094ff svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m503.61,303.36c4.32,4.92,10.67,7.57,17.21,7.18,11.43-.68,21.34,7.83,22.4,19.23.6,6.52,4.18,12.4,9.7,15.92,9.65,6.17,12.66,18.88,6.82,28.73-3.34,5.63-3.9,12.49-1.51,18.59,4.18,10.66-.85,22.72-11.37,27.25-6.01,2.59-10.5,7.81-12.15,14.15-2.89,11.08-14.04,17.88-25.21,15.36-6.39-1.44-13.08.15-18.14,4.31-8.85,7.27-21.87,6.21-29.43-2.39-4.32-4.92-10.67-7.57-17.21-7.18h0c-11.43.68-21.34-7.83-22.4-19.23-.6-6.52-4.19-12.4-9.7-15.93h0c-9.65-6.17-12.66-18.88-6.82-28.73,3.34-5.63,3.9-12.49,1.51-18.59-4.18-10.66.85-22.72,11.37-27.25h0c6.01-2.59,10.5-7.81,12.15-14.15,2.89-11.08,14.04-17.88,25.21-15.36h0c6.39,1.44,13.08-.15,18.14-4.31,8.85-7.27,21.87-6.21,29.43,2.39Z",
    className: "color0094ff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f4f8",
    d: "m441.43,353.34c-7.17,17.83-4.57,38.93,8.59,54.73,13.16,15.8,33.44,22.16,52.27,18.33,5.1-12.68,5.25-27.02.17-39.93,6.24.63,12.72-1.16,17.92-5.49,10.28-8.56,11.67-23.84,3.11-34.12s-23.84-11.68-34.12-3.11c-5.2,4.34-8.13,10.39-8.64,16.64-11.78-7.33-25.91-9.77-39.3-7.04Z",
    className: "colorfff6ef svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m410.69,502.26c-1.33-3.1-1.19-6.19-1.52-9.53-.57-6.68-7.92-8.34-12.2-12.17-3.32-2.62-6.36-5.58-8.92-8.9-4.83-6.45-6.62-11.89-15.43-14.27-1.17-.39-2.8-1.22-3.25-2.24-.1-.32-.11-.28.02-.8.14-.49.57-1.3,1.13-2.3,1.06-1.91,3.8-6.86,4.8-8.73,2.71-4.35,1.32-9.23-4.09-10.05-2.1-.43-7.58-1.51-9.77-1.94-2.07-.46-4.76-.95-5.95-2.58-.36-.96.33-1.86.96-3.05.26-.46.54-.91.83-1.35,2.39-.03,4.77-.15,7.14-.39,3.48-.28,7.98-.99,10.77-3.9,2.39-2.5,3.01-6.19,1.4-9.41-1.87-3.69-6.49-3.95-9.59-2.48-5.68,2.31-10.63,6.13-14.38,10.99-.38.48-.77.99-1.13,1.52-8.92.33-17.87-.7-26.66-2.93,7.73,3.49,16.16,5.58,24.72,6.31-1.47,3.27-1.77,6.84,1.15,9.91,4.2,4.24,10.67,4.36,15.85,5.63.17.03,1.4.28,2.43.48-1.06,1.97-3.58,6.74-4.58,8.66-2.93,4.68-2.71,9.8,2.24,13.06,2.71,1.95,6.38,2.05,8.99,3.86,3.06,2.3,5.29,6.58,8.12,9.55,3.1,3.48,6.6,6.59,10.47,9.13,1.93,1.27,3.95,2.42,6.01,3.42,2.02.97,3.8,1.83,4.76,3.11,1.01,1.26,1.31,3.34,1.66,5.57.93,6.83,5.92,13.16,12.29,15.47-3.83-2.26-6.72-5.76-8.26-9.68Zm-43.9-87.02c1.15-.71,3.25-1.82,4.36-1.92.26.03.19-.06.43.18.51.85.38,2.18-.29,2.94-1.86,2-4.58,2.33-7.51,2.93-.95.17-1.9.33-2.84.47,1.74-1.77,3.71-3.32,5.85-4.59Zm2.79,23.64s0-.03,0,0h0Z",
    className: "color0094ff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9e4ff",
    d: "m305.32 443.09 72.05 92.72c.59.76 1.69.91 2.46.33l12.48-9.41c.79-.59.94-1.72.33-2.49l-72.05-92.72c-.59-.76-1.69-.91-2.46-.33l-12.48 9.41c-.79.59-.94 1.72-.33 2.49ZM524.46 690.92l12.48-9.41c.77-.58 1.87-.44 2.46.33l67.04 86.28c.59.77.46 1.87-.3 2.47l-12.26 9.69c-.77.61-1.89.47-2.49-.3l-67.26-86.56c-.6-.78-.46-1.9.33-2.49ZM497.03 630.14l-12.48 9.41c-.79.59-.94 1.72-.33 2.49l32.12 41.33c.59.76 1.69.91 2.46.33l12.48-9.41c.79-.59.94-1.72.33-2.49l-32.12-41.33c-.59-.76-1.69-.91-2.46-.33ZM429.02 568.19l12.16-9.82c.77-.62 1.9-.49 2.5.29l48 61.78c.6.78.46 1.9-.33 2.49l-12.48 9.41c-.77.58-1.87.44-2.46-.33l-47.68-61.36c-.59-.76-.46-1.85.28-2.46ZM572.05 692.78l12.48-9.41c.77-.58 1.87-.44 2.46.33l48.04 61.83c.59.77.46 1.87-.3 2.47l-12.27 9.69c-.77.61-1.89.47-2.49-.3l-48.25-62.11c-.6-.78-.46-1.9.33-2.49ZM579.19 673.67l-72.05-92.72c-.59-.76-1.69-.91-2.46-.33l-12.48 9.41c-.79.59-.94 1.72-.33 2.49l72.05 92.72c.59.76 1.69.91 2.46.33l12.48-9.41c.79-.59.94-1.72.33-2.49ZM457.37 545.29l12.16-9.83c.77-.62 1.9-.49 2.5.29l27.31 35.15c.6.78.46 1.9-.33 2.49l-12.48 9.41c-.77.58-1.86.44-2.46-.33l-26.99-34.73c-.59-.76-.46-1.85.28-2.46Z",
    className: "colorffd5c9 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    d: "M541.85 577.52c-.27-.38-.38-.79-.31-1.21.07-.42.26-.75.58-.99l3.35-2.5c-1.62-2.9-2.6-5.59-2.94-8.09-.34-2.5-.17-4.69.49-6.57.66-1.88 1.7-3.41 3.12-4.57.25-.19.57-.25.94-.18.37.07.66.26.89.58l4.68 6.58c.35.49.53.92.56 1.3.03.38-.01.77-.12 1.17-.28.64-.46 1.37-.55 2.21-.09.84.02 1.77.34 2.79.31 1.02.9 2.14 1.77 3.36 1.44 2.02 2.81 3.33 4.11 3.93 1.3.6 2.45.53 3.44-.21.73-.55 1.12-1.27 1.18-2.16.05-.89-.18-2.09-.69-3.6-.51-1.51-1.31-3.44-2.39-5.78-1.37-3.03-2.32-5.78-2.83-8.25-.51-2.47-.45-4.69.18-6.65.63-1.96 1.93-3.68 3.91-5.16 2.55-1.91 5.43-2.53 8.64-1.86 3.21.67 6.29 2.59 9.24 5.78l3.35-2.5c.35-.26.72-.35 1.12-.28.4.08.73.31 1 .69l3.09 4.33c.25.35.35.74.32 1.16-.04.43-.23.77-.58 1.04l-3.44 2.57c1.33 2.69 2.08 5.22 2.26 7.6.18 2.38-.05 4.45-.69 6.24-.64 1.78-1.52 3.12-2.64 4.01-.26.19-.56.26-.92.2-.36-.05-.65-.24-.87-.55l-4.91-6.89c-.27-.38-.44-.76-.51-1.14-.07-.37-.04-.77.1-1.2.55-.73.77-1.75.65-3.05-.12-1.3-.67-2.65-1.66-4.04-1.09-1.53-2.19-2.54-3.29-3.02-1.1-.48-2.16-.34-3.18.42-.64.48-1.03 1.13-1.17 1.96-.14.83 0 1.92.43 3.28.43 1.36 1.13 3.14 2.12 5.34 1.71 3.57 2.86 6.64 3.43 9.2.57 2.56.54 4.77-.11 6.64-.65 1.87-1.94 3.53-3.89 4.99-1.88 1.41-3.91 2.13-6.07 2.18-2.17.05-4.35-.52-6.56-1.7-2.21-1.18-4.33-2.9-6.38-5.15l-3.35 2.5c-.32.24-.69.32-1.12.23-.43-.08-.76-.3-1.01-.65l-3.09-4.33ZM572.68 619.12c-.27-.38-.38-.79-.31-1.21.07-.42.26-.75.58-.99l3.35-2.5c-1.62-2.9-2.6-5.59-2.94-8.09-.34-2.5-.17-4.69.49-6.57.66-1.88 1.7-3.41 3.12-4.57.25-.19.57-.25.94-.18.37.07.66.26.89.58l4.68 6.58c.35.49.53.92.56 1.3.03.38-.01.77-.12 1.17-.28.64-.46 1.37-.55 2.21-.09.84.02 1.77.34 2.79.31 1.02.9 2.14 1.77 3.36 1.44 2.02 2.81 3.33 4.11 3.93 1.3.6 2.45.53 3.44-.21.73-.55 1.12-1.27 1.18-2.16.05-.89-.18-2.09-.69-3.6-.51-1.51-1.31-3.44-2.39-5.78-1.37-3.03-2.32-5.78-2.83-8.25-.51-2.47-.45-4.69.18-6.65.63-1.96 1.93-3.68 3.91-5.16 2.55-1.91 5.43-2.53 8.64-1.86 3.21.67 6.29 2.59 9.24 5.78l3.35-2.5c.35-.26.72-.35 1.12-.28.4.08.73.31 1 .69l3.09 4.33c.25.35.35.74.32 1.16-.04.43-.23.77-.58 1.04l-3.44 2.57c1.33 2.69 2.08 5.22 2.26 7.6.18 2.38-.05 4.45-.69 6.24-.64 1.78-1.52 3.12-2.64 4.01-.26.19-.56.26-.92.2-.36-.05-.65-.24-.87-.55l-4.91-6.89c-.27-.38-.44-.76-.51-1.14-.07-.37-.04-.77.1-1.2.55-.73.77-1.75.65-3.05-.12-1.3-.67-2.65-1.66-4.04-1.09-1.53-2.19-2.54-3.29-3.02-1.1-.48-2.16-.34-3.18.42-.64.48-1.03 1.13-1.17 1.96-.14.83 0 1.92.43 3.28.43 1.36 1.13 3.14 2.12 5.34 1.71 3.57 2.86 6.64 3.43 9.2.57 2.56.54 4.77-.11 6.64-.65 1.87-1.94 3.53-3.89 4.99-1.88 1.41-3.91 2.13-6.07 2.18-2.17.05-4.35-.52-6.56-1.7-2.21-1.18-4.33-2.9-6.38-5.15l-3.35 2.5c-.32.24-.69.32-1.12.23-.43-.08-.76-.3-1.01-.65l-3.09-4.33ZM603.51 660.72c-.27-.38-.38-.79-.31-1.21.07-.42.26-.75.58-.99l3.35-2.5c-1.62-2.9-2.6-5.59-2.94-8.09-.34-2.5-.17-4.69.49-6.57.66-1.88 1.7-3.41 3.12-4.57.25-.19.57-.25.94-.18.37.07.66.26.89.58l4.68 6.58c.35.49.53.92.56 1.3.03.38-.01.77-.12 1.17-.28.64-.46 1.37-.55 2.21-.09.84.02 1.77.34 2.79.31 1.02.9 2.14 1.77 3.36 1.44 2.02 2.81 3.33 4.11 3.93 1.3.6 2.45.53 3.44-.21.73-.55 1.12-1.27 1.18-2.16.05-.89-.18-2.09-.69-3.6-.51-1.51-1.31-3.44-2.39-5.78-1.37-3.03-2.32-5.78-2.83-8.25-.51-2.47-.45-4.69.18-6.65.63-1.96 1.93-3.68 3.91-5.16 2.55-1.91 5.43-2.53 8.64-1.86 3.21.67 6.29 2.59 9.24 5.78l3.35-2.5c.35-.26.72-.35 1.12-.28.4.08.73.31 1 .69l3.09 4.33c.25.35.35.74.32 1.16-.04.43-.23.77-.58 1.04l-3.44 2.57c1.33 2.69 2.08 5.22 2.26 7.6.18 2.38-.05 4.45-.69 6.24-.64 1.78-1.52 3.12-2.64 4.01-.26.19-.56.26-.92.2-.36-.05-.65-.24-.87-.55l-4.91-6.89c-.27-.38-.44-.76-.51-1.14-.07-.37-.04-.77.1-1.2.55-.73.77-1.75.65-3.05-.12-1.3-.67-2.65-1.66-4.04-1.09-1.53-2.19-2.54-3.29-3.02-1.1-.48-2.16-.34-3.18.42-.64.48-1.03 1.13-1.17 1.96-.14.83 0 1.92.43 3.28.43 1.36 1.13 3.14 2.12 5.34 1.71 3.57 2.86 6.64 3.43 9.2.57 2.56.54 4.77-.11 6.64-.65 1.87-1.94 3.53-3.89 4.99-1.88 1.41-3.91 2.13-6.07 2.18-2.17.05-4.35-.52-6.56-1.7-2.21-1.18-4.33-2.9-6.38-5.15l-3.35 2.5c-.32.24-.69.32-1.12.23-.43-.08-.76-.3-1.01-.65l-3.09-4.33Z",
    className: "colorffcb00 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9e4ff",
    d: "m658.51 591.33 12.48-9.41c.77-.58 1.87-.44 2.46.33l67.04 86.28c.59.77.46 1.87-.3 2.47l-12.26 9.69c-.77.61-1.89.47-2.49-.3l-67.26-86.56c-.6-.78-.46-1.9.33-2.49ZM631.07 530.56l-12.48 9.41c-.79.59-.94 1.72-.33 2.49l32.12 41.33c.59.76 1.69.91 2.46.33l12.48-9.41c.79-.59.94-1.72.33-2.49l-32.12-41.33c-.59-.76-1.69-.91-2.46-.33ZM563.07 468.6l12.16-9.82c.77-.62 1.9-.49 2.5.29l48 61.78c.6.78.46 1.9-.33 2.49l-12.48 9.41c-.77.58-1.87.44-2.46-.33l-47.68-61.36c-.59-.76-.46-1.85.28-2.46ZM706.1 593.2l12.48-9.41c.77-.58 1.87-.44 2.46.33l48.04 61.83c.59.77.46 1.87-.3 2.47l-12.27 9.69c-.77.61-1.89.47-2.49-.3l-48.25-62.11c-.6-.78-.46-1.9.33-2.49ZM713.24 574.08l-72.05-92.72c-.59-.76-1.69-.91-2.46-.33l-12.48 9.41c-.79.59-.94 1.72-.33 2.49l72.05 92.72c.59.76 1.69.91 2.46.33l12.48-9.41c.79-.59.94-1.72.33-2.49ZM591.42 445.71l12.16-9.83c.77-.62 1.9-.49 2.5.29l27.31 35.15c.6.78.46 1.9-.33 2.49l-12.48 9.41c-.77.58-1.86.44-2.46-.33l-26.99-34.73c-.59-.76-.46-1.85.28-2.46Z",
    className: "colorffd5c9 svgShape"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 834.4 460.53"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m505.47,115.07c-6.97-16.08,17.64-47.86,35.07-69.07,24.82-30.2-5.87-53.42-30.21-33.69-75.68,61.34-150.95,134.03-180.96,145.54-88.45,33.92-288.94,15.73-288.94,15.73,0,0-22.46,170.84,35.48,280.76,0,0,232.36-72.85,294.53-73.74,43.72-.63,108.77-3.99,177.57-9.77l215.23-15.71c8.93-.65,16.09-6.24,14.8-18.37-1.14-10.81-7.02-14.22-14.98-14.75l-136.89-10.07,183.04-27.63c8.53-1.54,17.22-8.72,16.06-22.2-1.06-12.27-12.39-15.51-20.81-14.91l-178.86,3.88,192.02-36c8.07-2.15,13.37-11.12,11.32-24.73-.81-5.4-8.98-14.04-17.34-13.28l-196.95,10.41,157.59-53.21c12.45-5.32,14.97-16.86,10.87-26.52h0c-2.32-8.36-10.84-13.38-19.27-11.35-44.72,10.73-162.83,31.57-175.14,33.34-32.61,4.69-71.86,11.61-83.25-14.64Z",
    className: "colorffcb00 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m508.16,178.18c8.29,41.11-25.12,89.95-75.58,87.61",
    className: "colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4,
    cy: 313.94,
    fill: "#9c27b0",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    rx: 48.61,
    ry: 142.57,
    transform: "rotate(-7.14 56.434 314.074)",
    className: "colorfe8628 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m318,196.99c-26.72,32.37-17.66,123.73,22.74,151.41",
    className: "colorffcb00 svgShape colorStroke232526 svgStroke"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 510.12 383.55"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m477.35,79.15s28.73-9.11,29.19-3.04c.47,6.07-30.36,70.53-30.36,70.53l-303.65,230.91c-17.94,13.65-43.98,2.71-46.7-19.67-1.23-10.11.08-19.32,6.8-24.16,20.09-14.48,344.72-254.57,344.72-254.57Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m206.85,323.87l-37.69,28.73c-5.06,3.86-11.02,5.72-16.92,5.72-8.43,0-16.75-3.79-22.26-11-9.35-12.28-6.99-29.82,5.29-39.18l37.63-28.68c9.1,3.22,32.8,14.45,33.95,44.42Z",
    className: "color2b4740 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m465.29,126.91l-258.44,196.96c-1.15-29.96-24.85-41.2-33.95-44.42L431.39,82.44c12.28-9.35,29.82-6.99,39.18,5.29,9.35,12.28,6.99,29.82-5.29,39.18Z",
    className: "colorfe8628 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m435.76,79.76l69.36-21.08-35.13,63.52s5.3-33.81-34.23-42.44Z",
    className: "colorffcb00 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m485,64.6s8.8,5.39,9.34,10.78l8.09-14.55-17.43,3.77Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.35,
    x2: 196.78,
    y1: 259.17,
    y2: 292.99,
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    className: "colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.88,
    x2: 260.15,
    y1: 94.13,
    y2: 244.91,
    fill: "none",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    className: "colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m402.51,26.86s8.62,8.15,7.19,13.42c-1.44,5.27-13.42,14.37-13.42,14.37,0,0,2.4,13.42,2.4,18.69S91.05,307.65,91.05,307.65c0,0-83.85,25.4-85.29,21.08-1.44-4.31,5.27-17.73,5.27-17.73L402.51,26.86Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m401.67,10.42c-4.61-6.05-13.26-7.22-19.31-2.61l-26.07,19.87c3.88,2.6,17.21,15.86,18.97,20.19l23.8-18.14c6.05-4.61,7.22-13.26,2.61-19.31Z",
    className: "color2b4740 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m374.85,67.22L78.73,292.91c-12.28,9.35-29.82,6.99-39.18-5.29-9.35-12.28-6.99-29.82,5.29-39.18L340.96,22.76c5.06-3.86,11.02-5.72,16.92-5.72,8.43,0,16.75,3.79,22.26,11,9.35,12.28,6.99,29.82-5.29,39.18Z",
    className: "color0094ff svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9e4ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m74.36,295.59l-69.36,21.08,35.13-63.52s34.15,3.7,34.23,42.44Z",
    className: "colorffd5c9 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m205.33,195.05c-.02.43-.02.85,0,1.27l-94.99,72.39c-4.15,3.16-4.37,2.68-4.37,2.68-.08-38.73-34.23-42.44-34.23-42.44,0,0-.02-1.1,4.7-4.71l94.46-71.99.39.62s34.98,10.06,34.02,42.17Z",
    className: "color2b4740 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m25.12,310.75s-8.8-5.39-9.34-10.78l-8.09,14.55,17.43-3.77Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#232526",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    points: "327.64 27.46 306.95 24.71 225.31 87.23"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    viewBox: "0 0 446.77 512.69"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m300.05,49.25c-76,0-137.64,61.64-137.64,137.64s61.64,137.64,137.64,137.64,137.64-61.61,137.64-137.64-61.61-137.64-137.64-137.64Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.12,
    cy: 164.06,
    r: 137.64,
    fill: "#9c27b0",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    transform: "rotate(-9.22 304.016 164.005)",
    className: "colorfe8628 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.37,
    cy: 142.64,
    r: 137.64,
    fill: "#0080ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    transform: "rotate(-9.22 302.31 142.585)",
    className: "colorffcb00 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f4f8",
    d: "m302.37,244.39c-56.18,0-101.72-45.57-101.72-101.75s45.53-101.72,101.72-101.72,101.75,45.53,101.75,101.72-45.57,101.75-101.75,101.75Z",
    className: "colorfff6ef svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m322.88,226.96c-30.45,6.12-63.22-4.25-84.43-29.83-21.22-25.59-25.34-59.7-13.68-88.48,21.66-4.36,44.5-.36,63.51,11.53.84-10.11,5.6-19.88,14.02-26.86,16.65-13.81,41.33-11.5,55.14,5.15,13.81,16.65,11.51,41.34-5.14,55.15-8.43,6.99-18.91,9.85-29,8.81,8.16,20.88,7.87,44.06-.42,64.54Z",
    className: "color0094ff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m274,381.29l-7.38-1.63c-1.22-11.04-4.4-21.57-9.18-31.21l5.54-5.46c7.33-7.23,8.02-18.82,1.6-26.87-3.45-4.32-8.34-6.87-13.48-7.45-4.43-.5-9.05.46-13.07,3.02l-6.99,4.46c-8.27-6.45-17.68-11.55-27.95-14.96l.07-8.8c.07-10.3-7.64-18.98-17.86-20.13-5.11-.58-10.03.82-13.95,3.62-3.92,2.8-6.84,7-7.95,12.02l-2.06,9.3c-10.31,1.35-20.16,4.39-29.23,8.87l-7.03-7.13c-7.22-7.33-18.82-8.02-26.87-1.6-4.32,3.45-6.87,8.34-7.45,13.48-.5,4.43.46,9.05,3.02,13.07l5.67,8.88c-6.03,7.77-10.86,16.54-14.24,26.08l-10.73-.07c-10.29-.07-18.97,7.63-20.13,17.86-.58,5.12.82,10.02,3.62,13.94,2.81,3.92,7.01,6.85,12.02,7.96l10.47,2.32c1.16,10.04,3.92,19.68,8.06,28.59l-7.51,7.39c-7.33,7.23-8.02,18.83-1.6,26.87,3.45,4.32,8.34,6.87,13.49,7.45,4.43.5,9.04-.46,13.06-3.02l8.45-5.39c7.84,6.39,16.77,11.54,26.51,15.15l-.07,9.53c-.07,10.29,7.64,18.97,17.86,20.13,5.11.58,10.03-.82,13.95-3.62,3.92-2.81,6.83-7.01,7.95-12.02l1.9-8.59c10.77-1.03,21.09-3.91,30.59-8.34l5.82,5.9c7.23,7.33,18.82,8.02,26.87,1.6,4.32-3.45,6.88-8.34,7.46-13.49.5-4.43-.47-9.04-3.02-13.06l-4.19-6.57c6.82-8.33,12.26-17.88,15.91-28.37l7.56.05c10.3.08,18.97-7.63,20.13-17.85h0c1.15-10.23-5.59-19.68-15.64-21.91Zm-47.69,16.56c-4.13,28.45-30.01,49.09-58.67,46.78-31.65-2.56-54.51-31.23-49.95-62.65,4.14-28.45,30.03-49.1,58.68-46.78,31.65,2.55,54.51,31.23,49.94,62.65Z",
    className: "color232526 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    d: "m230.61,379.77c-4.13,28.45-30.01,49.09-58.67,46.78-31.65-2.56-54.51-31.23-49.95-62.65,4.14-28.45,30.03-49.1,58.68-46.78,31.65,2.55,54.51,31.23,49.94,62.65Z",
    className: "colorffcb00 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m152.24,387.42c-.31-.39-.44-.82-.37-1.28.07-.46.28-.84.63-1.12l3.73-3c-1.88-2.99-3.03-5.83-3.46-8.5-.42-2.67-.28-5.06.44-7.15.71-2.1,1.86-3.84,3.44-5.22.28-.23.63-.32,1.05-.27.42.05.75.23,1.01.55l5.4,6.72c.4.5.62.95.66,1.36.04.41,0,.84-.11,1.28-.3.71-.5,1.53-.58,2.44-.08.92.06,1.91.43,2.99.37,1.08,1.05,2.24,2.06,3.48,1.66,2.06,3.23,3.36,4.71,3.89,1.48.53,2.77.36,3.88-.53.82-.66,1.25-1.47,1.29-2.44.04-.97-.24-2.25-.85-3.84-.61-1.59-1.54-3.61-2.8-6.05-1.6-3.16-2.72-6.05-3.34-8.68-.62-2.63-.6-5.04.08-7.22.67-2.18,2.11-4.16,4.32-5.93,2.84-2.29,6.08-3.21,9.72-2.77,3.63.44,7.14,2.26,10.53,5.45l3.73-3c.39-.31.81-.45,1.26-.4.45.05.83.27,1.14.66l3.56,4.42c.29.35.41.77.38,1.23-.03.47-.25.86-.64,1.17l-3.84,3.09c1.55,2.79,2.44,5.47,2.68,8.03.24,2.56.02,4.83-.67,6.81-.69,1.99-1.65,3.51-2.91,4.58-.29.23-.63.33-1.03.3-.4-.03-.73-.2-.99-.52l-5.66-7.04c-.31-.39-.52-.79-.6-1.18-.09-.4-.06-.83.09-1.3.61-.84.84-1.96.68-3.36-.16-1.4-.81-2.81-1.95-4.23-1.26-1.56-2.51-2.56-3.76-2.99-1.25-.43-2.45-.18-3.58.73-.71.57-1.14,1.31-1.29,2.22-.15.91.03,2.08.54,3.51.51,1.43,1.34,3.3,2.48,5.6,2,3.72,3.34,6.94,4.04,9.66.69,2.72.69,5.12,0,7.2-.7,2.08-2.13,3.99-4.3,5.74-2.1,1.69-4.37,2.65-6.81,2.89-2.44.24-4.92-.19-7.43-1.27-2.51-1.08-4.94-2.76-7.29-5.02l-3.73,3c-.35.29-.77.4-1.25.35-.48-.05-.86-.26-1.15-.61l-3.56-4.42Z",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9e4ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m278.3,363.21l-7.38-1.63c-1.22-11.04-4.4-21.57-9.18-31.21l5.54-5.46c7.33-7.23,8.02-18.82,1.6-26.87-3.45-4.32-8.34-6.87-13.48-7.45-4.43-.5-9.05.46-13.07,3.02l-6.99,4.46c-8.27-6.45-17.68-11.55-27.95-14.96l.07-8.8c.07-10.3-7.64-18.98-17.86-20.13-5.11-.58-10.03.82-13.95,3.62-3.92,2.8-6.84,7-7.95,12.02l-2.06,9.3c-10.31,1.35-20.16,4.39-29.23,8.87l-7.03-7.13c-7.22-7.33-18.82-8.02-26.87-1.6-4.32,3.45-6.87,8.34-7.45,13.48-.5,4.43.46,9.05,3.02,13.07l5.67,8.88c-6.03,7.77-10.86,16.54-14.24,26.08l-10.73-.07c-10.29-.07-18.97,7.63-20.13,17.86-.58,5.12.82,10.02,3.62,13.94,2.81,3.92,7,6.85,12.02,7.96l10.47,2.32c1.16,10.04,3.92,19.68,8.06,28.59l-7.51,7.39c-7.33,7.23-8.02,18.83-1.6,26.87,3.45,4.32,8.34,6.87,13.49,7.45,4.43.5,9.04-.46,13.06-3.02l8.45-5.39c7.84,6.39,16.77,11.54,26.51,15.15l-.07,9.53c-.07,10.29,7.64,18.98,17.86,20.13,5.11.58,10.03-.82,13.95-3.62,3.92-2.81,6.83-7.01,7.95-12.02l1.9-8.59c10.77-1.03,21.09-3.91,30.59-8.34l5.82,5.9c7.23,7.33,18.82,8.02,26.87,1.6,4.32-3.45,6.88-8.34,7.46-13.49.5-4.43-.47-9.04-3.02-13.06l-4.19-6.57c6.82-8.33,12.26-17.88,15.91-28.37l7.56.05c10.3.08,18.97-7.63,20.13-17.85h0c1.15-10.23-5.59-19.68-15.64-21.91Zm-47.69,16.56c-4.13,28.45-30.01,49.09-58.67,46.78-31.65-2.56-54.51-31.23-49.95-62.65,4.14-28.45,30.03-49.1,58.68-46.78,31.65,2.55,54.51,31.23,49.94,62.65Z",
    className: "colorffd5c9 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m148.88,193.73l-4.89-.8c-1.2-7.17-3.66-13.95-7.14-20.08l3.42-3.77c4.53-5,4.56-12.6.07-17.63-2.41-2.7-5.71-4.19-9.09-4.38-2.92-.17-5.9.63-8.44,2.45l-4.41,3.17c-5.64-3.92-11.99-6.91-18.83-8.77l-.28-5.76c-.33-6.74-5.69-12.13-12.42-12.52-3.36-.19-6.53.9-9,2.87-2.46,1.97-4.22,4.83-4.76,8.15l-1.01,6.16c-6.69,1.26-13.03,3.6-18.8,6.86l-4.86-4.41c-4.99-4.53-12.6-4.56-17.63-.07-2.7,2.41-4.19,5.71-4.38,9.09-.17,2.92.63,5.9,2.45,8.44l4.03,5.6c-3.66,5.3-6.5,11.22-8.36,17.58l-7.02.34c-6.73.33-12.13,5.68-12.52,12.42-.19,3.37.9,6.53,2.87,8.99,1.98,2.46,4.83,4.23,8.15,4.77l6.94,1.14c1.12,6.53,3.28,12.73,6.31,18.41l-4.64,5.11c-4.53,5-4.56,12.61-.07,17.63,2.41,2.7,5.71,4.19,9.09,4.38,2.92.17,5.9-.63,8.43-2.45l5.33-3.83c5.36,3.89,11.39,6.94,17.9,8.95l.3,6.24c.33,6.73,5.69,12.13,12.42,12.52,3.36.19,6.53-.9,9-2.87,2.46-1.98,4.21-4.83,4.76-8.15l.93-5.69c7.01-1.06,13.65-3.32,19.7-6.57l4.02,3.65c5,4.53,12.6,4.56,17.63.07,2.7-2.41,4.2-5.71,4.39-9.09.17-2.92-.64-5.9-2.45-8.43l-2.98-4.15c4.16-5.7,7.37-12.15,9.38-19.14l4.95-.24c6.74-.32,12.13-5.68,12.52-12.41h0c.38-6.74-4.37-12.67-11.03-13.76Zm-30.6,12.57c-1.67,18.76-17.85,33.2-36.68,32.74-20.8-.52-36.8-18.45-34.96-39.17,1.67-18.76,17.85-33.21,36.69-32.73,20.8.51,36.8,18.45,34.95,39.17Z",
    className: "color232526 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    d: "m122.65,197.29c-1.67,18.76-17.85,33.2-36.68,32.74-20.8-.52-36.8-18.45-34.96-39.17,1.67-18.76,17.85-33.21,36.69-32.73,20.8.51,36.8,18.45,34.95,39.17Z",
    className: "colorffcb00 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m71.61,205.08c-.22-.25-.32-.52-.29-.83.03-.31.15-.56.38-.76l2.34-2.09c-1.33-1.9-2.18-3.71-2.55-5.44-.37-1.73-.35-3.3.04-4.7.4-1.4,1.09-2.57,2.07-3.53.18-.16.4-.23.68-.22.27.02.5.12.68.32l3.76,4.21c.28.31.44.6.47.87.04.27.03.55-.03.84-.18.48-.27,1.02-.3,1.62-.02.6.1,1.25.38,1.94.28.69.77,1.43,1.46,2.21,1.15,1.29,2.23,2.09,3.21,2.39.99.3,1.83.14,2.52-.48.51-.46.76-1,.76-1.64,0-.64-.24-1.46-.69-2.48-.45-1.02-1.13-2.31-2.04-3.86-1.16-2.01-1.98-3.87-2.48-5.57-.5-1.7-.56-3.28-.19-4.73.37-1.45,1.24-2.79,2.62-4.03,1.78-1.59,3.87-2.31,6.26-2.14,2.39.17,4.75,1.24,7.07,3.21l2.34-2.09c.24-.22.51-.32.81-.3.29.02.55.15.77.39l2.48,2.77c.2.22.29.49.29.79,0,.31-.13.57-.38.79l-2.41,2.15c1.11,1.78,1.78,3.5,2.03,5.16.24,1.66.18,3.16-.2,4.48-.38,1.32-.96,2.35-1.75,3.09-.18.16-.4.24-.66.23-.26,0-.49-.11-.67-.31l-3.94-4.41c-.22-.25-.36-.5-.43-.75-.07-.26-.06-.54.02-.86.37-.57.48-1.31.33-2.22-.15-.91-.62-1.81-1.42-2.7-.88-.98-1.73-1.59-2.56-1.83-.83-.24-1.61-.04-2.32.6-.45.4-.7.9-.77,1.5-.07.6.09,1.36.47,2.28.38.92.99,2.11,1.81,3.58,1.43,2.37,2.42,4.43,2.97,6.18.55,1.76.63,3.33.24,4.71-.38,1.39-1.26,2.69-2.62,3.9-1.32,1.18-2.77,1.88-4.36,2.12-1.59.24-3.23.05-4.9-.58-1.68-.62-3.33-1.64-4.94-3.04l-2.34,2.09c-.22.2-.49.29-.81.27-.32-.02-.57-.14-.77-.36l-2.48-2.77Z",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9e4ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m153.24,184.72l-4.89-.8c-1.2-7.17-3.66-13.95-7.14-20.09l3.42-3.77c4.53-5,4.56-12.6.07-17.63-2.41-2.7-5.71-4.19-9.09-4.38-2.92-.17-5.9.63-8.44,2.45l-4.41,3.17c-5.64-3.92-11.99-6.91-18.83-8.77l-.28-5.76c-.33-6.74-5.69-12.13-12.42-12.52-3.36-.19-6.53.9-9,2.87-2.46,1.97-4.22,4.83-4.76,8.15l-1.01,6.16c-6.69,1.26-13.03,3.6-18.8,6.86l-4.86-4.41c-4.99-4.53-12.6-4.56-17.63-.07-2.7,2.41-4.19,5.71-4.38,9.09-.17,2.92.63,5.9,2.45,8.44l4.03,5.6c-3.66,5.3-6.5,11.22-8.36,17.58l-7.02.34c-6.73.33-12.13,5.68-12.52,12.42-.19,3.37.9,6.53,2.87,8.99,1.98,2.46,4.83,4.23,8.15,4.77l6.94,1.14c1.12,6.53,3.28,12.73,6.31,18.41l-4.64,5.11c-4.53,5-4.56,12.61-.07,17.63,2.41,2.7,5.71,4.19,9.09,4.38,2.92.17,5.9-.63,8.43-2.45l5.33-3.83c5.36,3.89,11.39,6.94,17.9,8.95l.3,6.24c.33,6.73,5.69,12.13,12.42,12.52,3.36.19,6.53-.9,9-2.87,2.46-1.98,4.21-4.83,4.76-8.15l.93-5.69c7.01-1.06,13.65-3.32,19.7-6.57l4.02,3.65c5,4.53,12.6,4.56,17.63.07,2.7-2.41,4.2-5.71,4.39-9.09.17-2.92-.64-5.9-2.45-8.43l-2.98-4.15c4.16-5.7,7.37-12.15,9.38-19.14l4.95-.24c6.74-.33,12.13-5.68,12.52-12.41h0c.38-6.74-4.37-12.67-11.03-13.76Zm-30.6,12.57c-1.67,18.76-17.85,33.2-36.68,32.74-20.8-.52-36.8-18.45-34.96-39.17,1.67-18.76,17.85-33.21,36.69-32.73,20.8.51,36.8,18.45,34.95,39.17Z",
    className: "colorffd5c9 svgShape colorStroke232526 svgStroke"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "g",
    viewBox: "0 0 444.5 476.46"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m434.54,252.53l-61.02-81.52-49.15,2.74-9.44,7.06c-3.59-7.53-7.95-14.79-13.08-21.7-36.72-49.38-102.35-65.74-161.61-45.32-29.15-25.89-75.56-27.32-110.63-1.25-5.34,3.97-15.57,11.57-21.63,17.37-1.82,1.74-2.04,4.56-.54,6.58l236.63,318.23c1.43,1.92,4.02,2.57,6.17,1.53,8.49-4.12,20.97-11.45,27.34-16.19,31.15-23.16,46.46-59.2,43.15-93.15l112.51-85.23c2.88-2.18,3.45-6.27,1.29-9.16Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9c27b0",
    points: "384.29 370.46 353.81 369.64 361.92 340.38 366.83 346.98 386.75 332.17 399.65 349.52 379.73 364.33 384.29 370.46",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9c27b0",
    points: "218.89 47.59 181.01 46.58 191.09 10.21 197.19 18.41 221.95 0 237.98 21.56 213.23 39.97 218.89 47.59",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m318.8,322.37c25.51,43.84,11.88,102.95-33.18,136.46-6.76,5.02-20.05,12.82-29,17.14-2.16,1.04-4.74.39-6.17-1.53L.99,138.95c-1.5-2.02-1.27-4.83.54-6.58,6.35-6.13,17.27-14.23,22.94-18.46,36.93-27.46,85.81-25.96,116.51,1.31,62.4-21.49,131.53-4.26,170.2,47.73,34.63,46.57,35.51,108.5,7.62,159.41Z",
    className: "color232526 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m289.82,426.55c-3.76,2.8-7.64,5.32-11.59,7.58-6.53,3.73-14.84,1.88-19.33-4.16L30.22,122.26c-2.05-2.76-3.09-6.14-2.95-9.57,1.3-12.89,4.3-31.49,4.3-31.49,0,0,92.74-6.52,121.88,19.28,59.61-20.73,125.45-4.66,162.09,44.61,32.82,44.13,33.37,103.02,6.55,151.56,24.12,41.57,10.86,97.84-32.27,129.91Z",
    className: "colorfe8628 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0f4f8",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    points: "308.82 334.36 227.05 225.12 335.77 143.74 374.57 149.81 439.5 236.55 308.82 334.36",
    className: "colorfff6ef svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0f4f8",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    points: "335.8 144.7 352.48 167.2 374.57 149.81 335.8 144.7",
    className: "colorfff6ef svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m403.93,238.59l-37.13-49.6c-.66-.88-.48-2.14.4-2.8l5.33-3.99c.88-.66,2.14-.48,2.8.4l37.13,49.6c.66.88.48,2.14-.4,2.8l-5.33,3.99c-.88.66-2.14.48-2.8-.4Z",
    className: "colorfe8628 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9e4ff",
    d: "m376.89 258.83-37.13-49.6c-.66-.88-.48-2.14.4-2.8l5.33-3.99c.88-.66 2.14-.48 2.8.4l37.13 49.6c.66.88.48 2.14-.4 2.8l-5.33 3.99c-.88.66-2.14.48-2.8-.4ZM333.32 269.08l-37.13-49.6c-.66-.88-.48-2.14.4-2.8l5.33-3.99c.88-.66 2.14-.48 2.8.4l37.13 49.6c.66.88.48 2.14-.4 2.8l-5.33 3.99c-.88.66-2.14.48-2.8-.4ZM331.8 198.58l-12.54-16.76c-.66-.88-.48-2.14.4-2.8l5.33-3.99c.88-.66 2.14-.48 2.8.4l12.54 16.76c.66.88.48 2.14-.4 2.8l-5.33 3.99c-.88.66-2.14.48-2.8-.4ZM303.29 193.77l37.13 49.6c.66.88 1.92 1.06 2.8.4l5.33-3.99c.88-.66 1.06-1.92.4-2.8l-37.13-49.6c-.66-.88-1.92-1.06-2.8-.4l-5.33 3.99c-.88.66-1.06 1.92-.4 2.8ZM348.38 254.02l12.54 16.76c.66.88 1.92 1.06 2.8.4l5.33-3.99c.88-.66 1.06-1.92.4-2.8l-12.54-16.76c-.66-.88-1.92-1.06-2.8-.4l-5.33 3.99c-.88.66-1.06 1.92-.4 2.8Z",
    className: "colorffd5c9 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0080ff",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m289.2,394.31c-3.07,2.28-6.23,4.35-9.46,6.2-6.59,3.78-14.97,2.03-19.51-4.07L34.06,92.28c-4.59-6.17-3.81-14.87,1.9-20.02,1.91-1.72,3.92-3.36,6.02-4.93,32.27-24,76.33-20.89,104.92,5.32,55.41-17.61,118.24.7,154.88,49.97,32.82,44.13,35.79,101.22,12.48,147.14,24.5,41.29,14.32,95.27-25.06,124.55Z",
    className: "colorffcb00 svgShape colorStroke232526 svgStroke"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0f4f8",
    points: "234.75 210.45 183.52 209.08 197.16 159.89 205.4 170.98 238.89 146.08 260.57 175.24 227.09 200.14 234.75 210.45",
    className: "colorfff6ef svgShape"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 1516.16,
    height: 1530.68,
    transform: "translate(885.89 797.54)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 311.01,
    height: 356.37,
    transform: "translate(1119.14 605.73)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 834.4,
    height: 460.53,
    transform: "translate(832.28 928.05)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 510.12,
    height: 383.55,
    transform: "translate(2089.56 1726.97)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 446.77,
    height: 512.69,
    transform: "translate(1687.38 2071.87)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    width: 893.95,
    height: 887.96,
    transform: "translate(1983.93 454.22)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    width: 444.5,
    height: 476.46,
    transform: "translate(1350.67 404.21)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManaged);
export default __webpack_public_path__ + "static/media/managed.3c8c7e9262de61b9cf166ed82568cad9.svg";
export { ForwardRef as ReactComponent };